/**
 * Meta descriptions over ~160 characters get cut off in search results, often
 * mid-word. fitMeta keeps a description whole when it fits, otherwise ends it
 * at the last full sentence, else the last whole word. Mirrored in
 * scripts/inject-canonicals.mjs, which writes the same tags into static HTML.
 */
export const META_MAX = 158;

export function fitMeta(text: string, max = META_MAX): string {
  const t = text.replace(/\s+/g, " ").trim();
  if (t.length <= max) return t;
  const cut = t.slice(0, max);
  const sentence = cut.lastIndexOf(". ");
  if (sentence >= max * 0.6) return cut.slice(0, sentence + 1);
  return cut.slice(0, cut.lastIndexOf(" ")).replace(/[,;:]$/, "") + "…";
}

/** "Term: definition", plus the glossary pointer when there's room for it. */
export function glossaryMeta(term: string, shortDef: string): string {
  const base = `${term}: ${shortDef}`.trim();
  const withTail = `${base} Explore the full definition and examples in the Indexed glossary.`;
  return withTail.length <= META_MAX ? withTail : fitMeta(base);
}
